export default __webpack_public_path__ + "static/media/correo.ad996b57.png";